module.exports = __webpack_public_path__ + "img/languageTwo.1150165a.png";